import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/users`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const usersApi = {
  async getUserProfile(payload) {
    return apiCall({
      url: `${BASE_URL}/getUserProfile`,
      method: "POST",
      data: payload
    });
  },
  async updateUserProfile(payload) {
    return apiCall({
      url: `${BASE_URL}/updateUserProfile`,
      method: "POST",
      data: payload
    });
  },
  async updateProfileImg(payload) {
    return apiCall({
      url: `${BASE_URL}/updateProfileImg`,
      method: "POST",
      data: payload
    });
  }
};

export const urlMakePageFetcherArtist = {
  url: "/ecommerce/users/getUserProfile",
  method: "POST"
};

export { withQuery };
